import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { BootstrapPayload } from "../../core";

const WorkspaceContext = createContext<BootstrapPayload | null>(null);

export function WorkspaceProvider({ value, children }: { value: BootstrapPayload; children: ReactNode }) {
    return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace(): BootstrapPayload {
    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("useWorkspace must be used within a WorkspaceProvider");
    return ctx;
}
